namespace Roodik.Core
{
	export class DragonBonesResourceLoader extends ResourceLoader
	{
		/*public load(provider:ResourceProvider, progressChanged:()=>void, resourcesLoaded:(resources)=>void)
		{
			let baseUrl = (window["cdnUrl"] == null || window["cdnUrl"] == undefined) ? "" : window["cdnUrl"];
			let loader = new PIXI.loaders.Loader();

			/!*PIXI.loader.add(this._name + "_ske.json", baseUrl + this._name + "_ske.json");
			PIXI.loader.add(this._name + "_tex.json", baseUrl + this._name + "_tex.json");
			PIXI.loader.add(this._name + "_tex.png", baseUrl + this._name + "_tex.png");*!/

			for(let i:number = 0; i < provider.sourceList.length; i++)
			{
				loader.add(provider.sourceList[i].name, baseUrl + provider.sourceList[i].url);
			}
			loader.on("progress", progressChanged);
			loader.load((loader, resources) =>
			{
				loader.off("progress", progressChanged);
				resourcesLoaded(resources);
			});
		}*/
		
		/*public parse(resources:dragonBones.Map<PIXI.loaders.Resource>)
		{
			const factory = dragonBones.PixiFactory.factory;
			factory.parseDragonBonesData(resources[this._name+"_ske.json"].data);
			factory.parseTextureAtlasData(resources[this._name+"_tex.json"].data,
			resources[this._name+"_tex.png"].texture);
		}*/
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Resources/DragonBonesResources.ts